import React, { lazy, Suspense } from "react";
import {
  Box,
  Button,
  Flex,
  Gap,
  Typography,
} from "../../../ppui";
import { Snackbar } from "../../../ppui/snackbar";
import ErrorBoundary from "../../../utils/error-boundary";
import AllowanceList from "./allowance-list";
import useAllowanceService from "./use-allowance-service";


const  AllowanceForm=lazy(()=>import("./allowance-form"))

function OrgAllowanceInfo() {

  const {
    
    allowancedialogOpen, setAllowancedialogOpen,
    allowanceListFetching,
    handleChangeFunction,
    allowance,
    onSubmitHandler,
    setAllowance,
   allowanceListResponse,
   ALLOWANCE_INITIAL_STATE,
   setAllowanceListResponse,
   onSubmitApi,
   getInputFieldProps,
   addAnotherAllowance, setaddAnotherAllowance,
    createUpdateLoading,
    setErrors,
  
  
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    totalAllowance
  }=useAllowanceService();



  return (
    <>
      <Box style={{ display: "none" }}>
        <Typography variant="h5">Allowance Information</Typography>
        <AllowanceForm />
      </Box>
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Allowance Information
        </Typography>
        <Button onClick={() => {
          setErrors({})
          setAllowance(ALLOWANCE_INITIAL_STATE);
          setAllowancedialogOpen(true)
        }} variant="outlined" size="sm">
          Add New
        </Button>
      </Flex>
      <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <Suspense fallback={<p>loading.....</p>}>
          <AllowanceList
         setAllowanceListResponse={setAllowanceListResponse}
         setErrors={setErrors}
            setAllowancedialogOpen={setAllowancedialogOpen}
            setAllowance={setAllowance}
            allowanceListResponse={allowanceListResponse}
            isFetching={allowanceListFetching} />
        </Suspense>
      </ErrorBoundary>
      <Gap height={100} />
      <Flex justifyContent="flex-end" gap={"10"}>
        <Button onClick={() => { }} variant="outlined">
          Cancel
        </Button>
       
        <Button color="primary" disabled={!allowanceListResponse?.length} loading={createUpdateLoading} onClick={() => { onSubmitApi() }} variant="contained">
        Save
        </Button>
      </Flex>
      <Gap height={100} />

   

  
       

   <Suspense fallback={<p>Loading dialog....</p>}>

   <AllowanceForm  
   handleChangeFunction={handleChangeFunction}
   allowance={allowance}
   onSubmitHandler={onSubmitHandler}
   getInputFieldProps={getInputFieldProps}
   allowancedialogOpen={allowancedialogOpen}
   setAllowancedialogOpen={setAllowancedialogOpen}
   addAnotherAllowance={addAnotherAllowance}
   totalAllowance={totalAllowance}
   setaddAnotherAllowance={setaddAnotherAllowance}
   />
   </Suspense>
   <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default OrgAllowanceInfo;
